import { ClickAwayListener } from "@mui/material";
import * as React from "react";
import { ColorResult, CompactPicker } from "react-color";
import { ColorBoxDiv, ColorPickerDiv, PickerContainer } from "./ColorPicker.styles";

// ColorPicker
// ***********************************************************************************************************************
export interface IColorPickerProp {
    autoFocus?: boolean;
    classes?: string;
    disabled?: boolean;
    openAlignRight?: boolean;
    value: string;
    requiredColors?: string[];
    onChange(value: string);
}

export interface IColorPickerState {
    open: boolean;
    colors: string[];
}

export class ColorPicker extends React.Component<IColorPickerProp, IColorPickerState> {
    defaultColors = [
        "#4D4D4D", "#999999", "#FFFFFF", "#F44E3B", "#FE9200", "#FCDC00", "#DBDF00", "#A4DD00", "#68CCCA", "#73D8FF", "#AEA1FF", "#FDA1FF",
        "#333333", "#808080", "#cccccc", "#D33115", "#E27300", "#FCC400", "#B0BC00", "#68BC00", "#16A5A5", "#009CE0", "#7B64FF", "#FA28FF",
        "#000000", "#666666", "#B3B3B3", "#9F0500", "#C45100", "#FB9E00", "#808900", "#194D33", "#0C797D", "#0062B1", "#653294", "#AB149E"
    ];

    constructor(props: IColorPickerProp) {
        super(props);
        const colors = this.defaultColors.slice(0);
        for (const color of props.requiredColors ?? []) {
            if (colors.indexOf(color) > -1) continue;
            colors.push(color);
        }
        this.state = {
            open: false,
            colors
        };
    }

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <ClickAwayListener onClickAway={() => this.setState({ open: false })}>
                <ColorPickerDiv>
                    <ColorBoxDiv disabled={props.disabled} style={{ backgroundColor: props.value }} onClick={props.disabled ? null : () => this.setState({ open: !state.open })}></ColorBoxDiv>
                    {state.open &&
                        <PickerContainer style={{ left: props.openAlignRight ? "auto" : null, right: props.openAlignRight ? 0 : null }}>
                            <CompactPicker
                                color={props.value}
                                colors={state.colors}
                                onChangeComplete={(color: ColorResult) => {
                                    props.onChange(color.hex);
                                    this.setState({ open: false });
                                }}
                            />
                        </PickerContainer>
                    }
                </ColorPickerDiv>
            </ClickAwayListener>
        );
    }
}